import { GraphQLClient } from 'graphql-request';
import { Observable, from, switchMap, take } from 'rxjs';
import { environment } from '../environment';
import { authService } from '../shared/services/auth/auth.service';

const rawAppEnv = import.meta.env.VITE_REACT_APP_ENV;
const appEnv: keyof typeof environment =
  rawAppEnv && rawAppEnv in environment ? (rawAppEnv as keyof typeof environment) : 'development';

const client = new GraphQLClient(environment[appEnv].consoleApi);

export const consoleGqlClient = (
  gql: string,
  variables: Record<string, any> = {},
): Observable<any> => {
  return authService.sub.idToken().pipe(
    switchMap((token) =>
      from(client.request(gql, variables, { Authorization: encodeURIComponent(token) })),
    ),
    take(1),
  );
};
